<template>
  <div class="box-list-company">
    <Navbar />
    <div class="list-company">
      <vue-good-table
        :search-options="{ enabled: true }"
        :columns="columns"
        :rows="rows"
        :pagination-options="{
          enabled: true,
          perPage: 10,
          position: 'bottom',
          perPageDropdown: [10, 25, 50],
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: 'ถัดไป',
          prevLabel: 'ก่อนหน้า',
          rowsPerPageLabel: 'จำนวนข้อมูลต่อหน้า',
          ofLabel: 'จาก',
        }"
        @on-row-click="selectCompany"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'ebidding_company_type'">
            <span
              v-if="props.row.approved === '1'"
              style="font-weight: bold; color: green"
              >{{ props.row.ebidding_company_type }}</span
            >
          </span>
          <span v-if="props.column.field == 'ebidding_company_type'">
            <span
              v-if="props.row.approved === '0' || props.row.approved === ''"
              style="font-weight: bold"
              >{{ props.row.ebidding_company_type }}</span
            >
          </span>
          <span v-if="props.column.field == 'ebidding_customer_name'">
            <span
              v-if="props.row.approved === '1'"
              style="font-weight: bold; color: green"
              >{{ props.row.ebidding_customer_name }}</span
            >
          </span>
          <span v-if="props.column.field == 'ebidding_customer_name'">
            <span
              v-if="props.row.approved === '0' || props.row.approved === ''"
              style="font-weight: bold"
              >{{ props.row.ebidding_customer_name }}</span
            >
          </span>
          <span v-if="props.column.field == 'approved_by'">
            <span
              v-if="props.row.approved === '1'"
              style="font-weight: bold; color: green"
              >{{ props.row.approved_by }}</span
            >
          </span>
          <span v-if="props.column.field == 'approved_by'">
            <span
              v-if="props.row.approved === '0' || props.row.approved === ''"
              style="font-weight: bold"
              >{{ props.row.approved_by }}</span
            >
          </span>
          <span v-if="props.column.field == 'ebidding_customer_tax'">
            <span
              v-if="props.row.approved === '1'"
              style="font-weight: bold; color: green"
              >{{ props.row.ebidding_customer_tax }}</span
            >
          </span>
          <span v-if="props.column.field == 'ebidding_customer_tax'">
            <span
              v-if="props.row.approved === '0' || props.row.approved === ''"
              style="font-weight: bold"
              >{{ props.row.ebidding_customer_tax }}</span
            >
          </span>
        </template>
        <div slot="table-actions">
          <b-button
            router-link
            to="/Inputcompany"
            size="sm"
            style="margin-right: 10px; background-color: #005a7c"
          >
            <font-awesome-icon icon="plus" />&nbsp;เพิ่มบริษัท/ห้าง
          </b-button>
          <b-button
            @click="modalUpload()"
            size="sm"
            style="margin-right: 10px; background-color: #005a7c"
          >
            <font-awesome-icon icon="upload" />&nbsp;อัพเดทข้อมูล
          </b-button>
          <b-button
            target="_blank"
            href="https://datawarehouse.dbd.go.th/"
            size="sm"
            style="margin-right: 10px; background-color: #005a7c"
          >
            <font-awesome-icon icon="search" />&nbsp;DBD DataWarehouse
          </b-button>
        </div>
      </vue-good-table>
    </div>
    <Footer />
    <b-modal
      ref="modal-com"
      size="lg"
      title="บริษัท/ห้าง"
      scrollable
      hide-footer
      centered
    >
      <b-form @submit="updateCom">
        <b-container fluid>
          <b-row>
            <b-col>
              <b>
                <u>ข้อมูลทั่วไป</u>
              </b>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col lg="5">
              <b-row>
                <b-col lg="5">
                  คำนำหน้า
                  <span class="required">&nbsp;*</span>
                </b-col>
                <b-col>
                  <b-form-select
                    :options="option_company_type"
                    v-model="form.ebidding_company_type"
                    size="sm"
                    required
                  ></b-form-select>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-row>
                <b-col lg="3">
                  ชื่อ
                  <span class="required">&nbsp;*</span>
                </b-col>
                <b-col>
                  <b-form-input
                    size="sm"
                    v-model="form.ebidding_customer_name"
                    required
                  ></b-form-input>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col lg="5">
              <b-row>
                <b-col lg="5">
                  ที่อยู่
                  <span class="required">&nbsp;*</span>
                </b-col>
                <b-col>
                  <b-form-textarea
                    size="sm"
                    v-model="form.ebidding_customer_addr1"
                    required
                    rows="6"
                  ></b-form-textarea>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-row>
                <b-col lg="3">
                  อำเภอ
                  <span class="required">&nbsp;*</span>
                </b-col>
                <b-col>
                  <ThailandAutoComplete
                    class="box-auto"
                    v-model="amphoe"
                    required
                    type="amphoe"
                    @select="select"
                  />
                </b-col>
              </b-row>
              <br />
              <b-row>
                <b-col lg="3">
                  จังหวัด
                  <span class="required">&nbsp;*</span>
                </b-col>
                <b-col>
                  <ThailandAutoComplete
                    class="box-auto"
                    v-model="province"
                    required
                    type="province"
                    @select="select"
                    disable
                  />
                </b-col>
              </b-row>
              <br />
              <b-row>
                <b-col lg="3">
                  ไปรษณีย์
                  <span class="required">&nbsp;*</span>
                </b-col>
                <b-col>
                  <ThailandAutoComplete
                    class="box-auto"
                    v-model="zipcode"
                    required
                    type="zipcode"
                    @select="select"
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col lg="5">
              <b-row>
                <b-col lg="5">เบอร์โทร</b-col>
                <b-col>
                  <b-form-input
                    size="sm"
                    v-model="form.ebidding_tel"
                  ></b-form-input>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-row>
                <b-col lg="3">Email</b-col>
                <b-col>
                  <b-form-input
                    size="sm"
                    v-model="form.ebidding_email"
                  ></b-form-input>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col lg="5">
              <b-row>
                <b-col lg="5">latitude</b-col>
                <b-col>
                  <b-form-input
                    size="sm"
                    v-model="form.latitude"
                  ></b-form-input>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-row>
                <b-col lg="3">longitude</b-col>
                <b-col>
                  <b-form-input
                    size="sm"
                    v-model="form.longitude"
                  ></b-form-input>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col lg="5">
              <b-row>
                <b-col lg="5">Line</b-col>
                <b-col>
                  <b-form-input
                    size="sm"
                    v-model="form.ebidding_line"
                  ></b-form-input>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col lg="5">
              <b-row>
                <b-col lg="5">
                  วันจดทะเบียน
                  <span class="required">&nbsp;*</span>
                </b-col>
                <b-col>
                  <b-form-input
                    size="sm"
                    required
                    v-model="form.ebidding_register_date"
                    ref="date-input"
                  ></b-form-input>
                  <small>วว/ดด/ปปปป (01/02/2563)</small>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-row>
                <b-col lg="4">
                  ทุนจดทะเบียน
                  <span class="required">&nbsp;*</span>
                </b-col>
                <b-col>
                  <b-form-input
                    size="sm"
                    required
                    v-model="form.ebidding_registered_capital"
                  ></b-form-input>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col lg="5">
              <b-row>
                <b-col lg="5">
                  เลขผู้เสียภาษี
                  <span class="required">&nbsp;*</span>
                </b-col>
                <b-col>
                  <b-form-input
                    size="sm"
                    required
                    v-model="form.ebidding_customer_tax"
                  ></b-form-input>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-row>
                <b-col lg="4">
                  การลงชื่อ
                  <span class="required">&nbsp;*</span>
                </b-col>
                <b-col>
                  <b-form-select
                    v-model="form.ebidding_sign_condition"
                    :options="options"
                    size="sm"
                    required
                  ></b-form-select>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <br />
          <b-row>
            <b-col lg="2">
              <b-form-checkbox
                v-model="form.ispartner"
                value="1"
                unchecked-value="0"
                >เป็น Partner</b-form-checkbox
              >
            </b-col>
            <b-col lg="2">
              <b-form-checkbox
                v-model="form.isnotfound"
                value="1"
                unchecked-value="0"
                >ไม่พบข้อมูล</b-form-checkbox
              >
            </b-col>
            <b-col lg="3" v-if="form.isnotfound === '1'">
              <b-form-textarea
                v-model="form.remarks"
                placeholder="หมายเหตุ"
                rows="2"
              ></b-form-textarea>
            </b-col>
          </b-row>
          <b-row class="mt-3"
            ><b-col>
              <b-row
                ><b-col lg="2">ผู้ติดตาม</b-col
                ><b-col lg="3"
                  ><b-form-select
                    v-model="form.follower"
                    :options="option_follower"
                  ></b-form-select></b-col
              ></b-row> </b-col
          ></b-row>
          <br />
          <br />
          <span v-if="form.isnocommittee === '0'">
            <b-row>
              <b-col>
                <b>
                  <u>กรรมการ/หุ้นส่วนผู้จัดการ</u>
                </b>
              </b-col>
            </b-row>
            <br />
            <b-row v-if="haveCommittee">
              <b-col lg="6">
                <b-row
                  class="mb-2"
                  v-for="(index, i) in object_committee"
                  :key="i"
                >
                  <b-col>
                    <b-row>
                      <b-col lg="4">
                        คนที่ {{ i + 1 }}
                        <span class="required">&nbsp;*</span>
                      </b-col>
                      <b-col>
                        <b-form-input
                          required
                          size="sm"
                          v-model="object_committee[i].committee_name"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row v-if="!haveCommittee">
              <b-col lg="6">
                <b-row class="mb-2">
                  <b-col>
                    <b-row>
                      <b-col lg="4">
                        ชื่อกรรมการ
                        <span class="required">&nbsp;*</span>
                      </b-col>
                      <b-col>
                        <b-form-textarea
                          required
                          size="sm"
                          v-model="committee"
                          @input="committee = committee.trim()"
                        ></b-form-textarea>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="6">
                <b-row class="mt-3">
                  <b-col>
                    <b-row>
                      <b-col lg="4">
                        ตำเเหน่ง
                        <span class="required">&nbsp;*</span>
                      </b-col>
                      <b-col>
                        <b-form-input
                          size="sm"
                          required
                          v-model="position"
                        ></b-form-input>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </span>
          <br />
          <b-row class="mt-3">
            <b-col>
              <b-button
                v-if="ctlLock && !approved"
                @click="lock"
                class="ml-2 float-right"
                variant="success"
                size="sm"
                >ล็อค</b-button
              >
              <b-button
                v-if="ctlLock && approved"
                @click="unlock"
                class="ml-2 float-right"
                variant="success"
                size="sm"
                >ปลดล็อค</b-button
              >
              <b-button
                type="submit"
                class="ml-2 float-right"
                size="sm"
                variant="warning"
                v-if="!approved"
                >เเก้ไขข้อมูล</b-button
              >
              <b-button
                class="ml-2 float-right"
                variant="danger"
                @click="closeCompany"
                size="sm"
                >ปิดหน้าต่าง</b-button
              >
            </b-col>
          </b-row>
          <br />
        </b-container>
      </b-form>
    </b-modal>
    <b-modal
      ref="modal-upload"
      size="sm"
      title="อัพเดทข้อมูลบริษัท"
      hide-footer
      centered
    >
      <b-form @submit="uploadData()">
        <b-container fluid>
          <b-row class="mb-2">
            <b-col>ไฟล์อัพเดทข้อมูล:</b-col>
          </b-row>
          <b-row class="mb-4">
            <b-col>
              <b-form-file
                @input="getBase64()"
                placeholder="คลิกเพื่อเลือก"
                v-model="file_upload"
                browse-text="ไฟล์"
                accept=".xls, .xlsx"
              ></b-form-file>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-center">
              <b-button block size="sm" variant="success"
                >อัพโหลดข้อมูล</b-button
              >
            </b-col>
            <b-col class="text-center"
              ><b-button block size="sm" variant="danger">ปิดหน้าต่าง</b-button>
            </b-col>
          </b-row>
        </b-container>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
import Navbar from "./Navbar";
import Footer from "./Footer";
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import ThailandAutoComplete from "vue-thailand-address-autocomplete";
import axios from "axios";
import XLSX from "xlsx";
export default {
  components: { Navbar, Footer, VueGoodTable, ThailandAutoComplete },
  data() {
    return {
      approved: false,
      ctlLock: false,
      columns: [
        {
          label: "คำนำหน้า",
          field: "ebidding_company_type",
          width: "10%",
        },
        {
          label: "เลขที่ผู้เสียภาษี",
          field: "ebidding_customer_tax",
          width: "10%",
        },
        {
          label: "ชื่อ",
          field: "ebidding_customer_name",
        },
        {
          label: "ยืนยันโดย",
          field: "approved_by",
          width: "10%",
        },
      ],
      rows: [],
      province: "",
      amphoe: "",
      zipcode: "",
      option_follower: [],
      form: {
        follower: null,
        ebidding_company_type: null,
        ebidding_customer_name: null,
        ebidding_customer_tax: null,
        ebidding_customer_addr1: null,
        ebidding_amphoe: null,
        ebidding_changwat: null,
        ebidding_customer_zipcode: null,
        ebidding_tel: "",
        ebidding_email: "",
        ebidding_line: "",
        ebidding_register_date: null,
        ebidding_registered_capital: null,
        ebidding_sign_condition: null,
        id: null,
        updateby: null,
        ispartner: "0",
        isnotfound: "0",
        remarks: "",
        isnocommittee: "0",
      },
      data_excel: [],
      file_upload: null,
      update_where: null,
      approved_by: null,
      object_committee: [],
      position: null,
      haveCommittee: false,
      committee: null,
      option_company_type: [],
      options: [
        { value: 1, text: "กรรมการหนึ่งคนลงลายมือชื่อ" },
        { value: 2, text: "กรรมการคนใดคนหนึ่งลงลายมือชื่อ" },
        {
          value: 3,
          text: "กรรมการหนึ่งคนลงลายมือชื่อและประทับตราสำคัญของบริษัท",
        },
        {
          value: 4,
          text: "กรรมการคนใดคนหนึ่งลงลายมือชื่อและประทับตราสำคัญของบริษัท",
        },
        { value: 5, text: "กรรมการสองคนลงลายมือชื่อร่วมกัน" },
        {
          value: 6,
          text: "กรรมการสองคนลงลายมือชื่อร่วมกันและประทับตราสำคัญของบริษัท",
        },
        { value: 7, text: "กรรมการสามคนลงลายมือชื่อร่วมกัน" },
      ],
      ipaddress: null,
    };
  },
  mounted() {
    this.$refs["modal-upload"].show();
    axios
      .get("https://www.kmppartners.info:1009/api/get/crm/user")
      .then((res) => {
        if (res.data.status) {
          for (let index = 0; index < res.data.response.length; index++) {
            this.option_follower.push(
              JSON.parse(
                '{"text": "' +
                  res.data.response[index].crm_sale_fullname +
                  '", "value": "' +
                  res.data.response[index].crm_sale_username +
                  '"}'
              )
            );
          }
        }
      });
    if (this.$session.get("role") === "Admin") {
      this.admin = true;
    } else {
      this.admin = false;
    }
    axios.get("http://www.geoplugin.net/json.gp").then((res) => {
      this.ipaddress = res.data.geoplugin_request;
    });
    axios
      .get("https://www.kmppartners.info:1009/api/ebidding/company_type")
      .then((res) => {
        if (res.data.statusCompany) {
          for (let index = 0; index < res.data.response.length; index++) {
            this.option_company_type.push(
              JSON.parse(
                '{"value": "' +
                  res.data.response[index].company_type +
                  '", "text": "' +
                  res.data.response[index].company_type +
                  '"}'
              )
            );
          }
        } else {
          this.$bvToast.toast(res.data.error, {
            title: "ผิดพลาด",
            autoHideDelay: 5000,
            appendToast: true,
            variant: "danger",
          });
        }
      });
    axios
      .get("https://www.kmppartners.info:1009/api/ebidding/customer/all")
      .then((res) => {
        if (res.data.statusCustomer) {
          this.rows = res.data.response;
        } else {
          this.$bvToast.toast(res.data.error, {
            title: "ผิดพลาด",
            autoHideDelay: 5000,
            appendToast: true,
            variant: "danger",
          });
        }
      });
  },
  methods: {
    getBase64: function () {
      this.data_excel = []
            if(this.file_upload.type === 'application/vnd.ms-excel' || this.file_upload.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
              let reader = new FileReader();
              reader.readAsArrayBuffer(this.file_upload);
              reader.onload = () => {
        let data = new Uint8Array(reader.result);
            let workbook = XLSX.read(data, {type: 'array'});
            let sheetName = workbook.SheetNames[0]
            let worksheet = workbook.Sheets[sheetName];
            let data_json = XLSX.utils.sheet_to_json(worksheet)
          

            for (let index = 0; index < data_json.length; index++) {
              if(index !== 0 && index !== 1){
                console.log(data_json[index].__EMPTY.replace("'",""))
                this.data_excel.push(data_json[index].__EMPTY.replace("'",""))
              }
            }
      };
            
        
      // axios.post("http://192.168.1.21:1009/api/ebidding/company-cancel",{file: this.file_upload}).then(res=>{
      //   if(res.data.status){
      //     console.log(1)
      //   }else{
      //     this.$bvToast.toast(res.data.error, {
      //       title: "ผิดพลาด",
      //       autoHideDelay: 5000,
      //       appendToast: true,
      //       variant: "danger",
      //     });
      //   }
      // })
          }
    },
    modalUpload() {
      this.$refs["modal-upload"].show();
    },
    closeCompany: function () {
      this.$refs["modal-com"].hide();
    },
    select(address) {
      this.amphoe = address.amphoe;
      this.province = address.province;
      this.zipcode = address.zipcode;
      this.form.ebidding_amphoe = this.amphoe;
      this.form.ebidding_changwat = this.province;
      this.form.ebidding_customer_zipcode = this.zipcode;
    },
    updateCom: function (e) {
      e.preventDefault();
      this.form.updateby = this.$session.get("username");
      this.form.id = this.update_where;
      let pattern = /^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;
      if (
        this.form.ebidding_amphoe === null ||
        this.form.ebidding_amphoe === "" ||
        this.form.ebidding_changwat === null ||
        this.form.ebidding_changwat === "" ||
        this.form.ebidding_customer_zipcode === null ||
        this.form.ebidding_customer_zipcode === ""
      ) {
        this.$bvToast.toast("กรุณากรอกข้อมูลให้ครบทุกช่อง", {
          title: "ผิดพลาด",
          autoHideDelay: 5000,
          appendToast: true,
          variant: "danger",
        });
      } else if (!pattern.test(this.form.ebidding_register_date)) {
        this.$bvToast.toast("กรุณากรอกวันที่ให้ถูกต้อง (วว/ดด/ปปปป)", {
          title: "ผิดพลาด",
          autoHideDelay: 3000,
          appendToast: true,
          variant: "danger",
        });
        this.$refs["date-input"].focus();
      } else {
        this.$bvModal
          .msgBoxConfirm(
            "ยืนยันว่าต้องการเเก้ไขข้อมูลบริษัท/ห้างหุ้นส่วนใช่หรือไม่",
            {
              title: "ต้องการดำเนินการต่อไหม?",
              size: "sm",
              buttonSize: "sm",
              okVariant: "success",
              cancelVariant: "danger",
              headerClass: "p-2 border-bottom-0",
              footerClass: "p-2 border-top-0",
              centered: true,
              okTitle: "ตกลง",
              cancelTitle: "ยกเลิก",
            }
          )
          .then((value) => {
            if (value) {
              axios
                .post(
                  "https://www.kmppartners.info:1009/api/update/customer",
                  this.form
                )
                .then((res) => {
                  if (res.data.statusUpdateCustomer) {
                    if (
                      this.position === null ||
                      this.object_committee.length === 0
                    ) {
                      axios
                        .post(
                          "https://www.kmppartners.info:1009/api/ebidding/add/committee",
                          {
                            name: this.committee.split("\n"),
                            position: this.position,
                            company_id: this.form.id,
                          }
                        )
                        .then((res) => {
                          if (res.data.statusAddCommittee) {
                            this.$bvModal
                              .msgBoxOk(
                                "บันทึกข้อมูลกรรมการ/หุ้นส่วนผู้จัดการเรียบร้อยเเล้ว",
                                {
                                  title: "สำเร็จ",
                                  size: "md",
                                  buttonSize: "sm",
                                  okVariant: "success",
                                  headerClass: "p-2 border-bottom-0",
                                  footerClass: "p-2 border-top-0",
                                  centered: true,
                                  okTitle: "ตกลง",
                                }
                              )
                              .then((value) => {
                                if (value) {
                                  axios
                                    .post(
                                      "https://www.kmppartners.info:1009/api/ebidding/access_log",
                                      {
                                        access_username: this.$session.get(
                                          "username"
                                        ),
                                        access_module:
                                          "เพิ่มกรรมการผู้ชนะ/หุ้นส่วนผู้จัดการ E-Bidding",
                                        access_ipaddress: this.ipaddress,
                                      }
                                    )
                                    .then((rest) => {
                                      if (rest.data.statusLog) {
                                        location.reload();
                                      }
                                    });
                                }
                              });
                          }
                        });
                    } else {
                      axios
                        .post(
                          "https://www.kmppartners.info:1009/api/update/committee/" +
                            this.position,
                          this.object_committee
                        )
                        .then((rest) => {
                          if (rest.data.statusUpdateCommittee) {
                            this.$bvModal
                              .msgBoxOk("บันทึกข้อมูลเรียบร้อยเเล้ว", {
                                title: "สำเร็จ",
                                size: "md",
                                buttonSize: "sm",
                                okVariant: "success",
                                headerClass: "p-2 border-bottom-0",
                                footerClass: "p-2 border-top-0",
                                centered: true,
                                okTitle: "ตกลง",
                              })
                              .then((value) => {
                                if (value) {
                                  axios
                                    .post(
                                      "https://www.kmppartners.info:1009/api/ebidding/access_log",
                                      {
                                        access_username: this.$session.get(
                                          "username"
                                        ),
                                        access_module:
                                          "เเก้ไขข้อมูลผู้ชนะ E-Bidding",
                                        access_ipaddress: this.ipaddress,
                                      }
                                    )
                                    .then((rest) => {
                                      if (rest.data.statusLog) {
                                        location.reload();
                                      }
                                    });
                                }
                              });
                          } else {
                            this.$bvToast.toast(rest.data.error, {
                              title: "ผิดพลาด",
                              autoHideDelay: 5000,
                              appendToast: true,
                              variant: "danger",
                            });
                          }
                        });
                    }
                  } else {
                    this.$bvModal
                      .msgBoxOk(res.data.error, {
                        title: "ไม่สำเร็จ",
                        size: "md",
                        buttonSize: "sm",
                        okVariant: "danger",
                        headerClass: "p-2 border-bottom-0",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                        okTitle: "ตกลง",
                      })
                      .then((value) => {
                        if (value) {
                          location.reload();
                        }
                      });
                  }
                });
            }
          });
      }
    },
    lock: function () {
      this.$bvModal
        .msgBoxConfirm("ยืนยันว่าล็อคข้อมูลไม่ให้เเก้ไขใช่หรือไม่", {
          title: "ต้องการดำเนินการต่อไหม?",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          cancelVariant: "danger",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
          okTitle: "ตกลง",
          cancelTitle: "ยกเลิก",
        })
        .then((value) => {
          if (value) {
            axios
              .post(
                "https://www.kmppartners.info:1009/api/ebidding_customer/approved",
                {
                  customer_id: this.update_where,
                  username: this.$session.get("username"),
                }
              )
              .then((res) => {
                if (res.data.status) {
                  this.$bvModal
                    .msgBoxOk("ดำเนินการเรียบร้อย", {
                      title: "สำเร็จ",
                      size: "sm",
                      buttonSize: "sm",
                      okVariant: "success",
                      headerClass: "p-2 border-bottom-0",
                      footerClass: "p-2 border-top-0",
                      centered: true,
                      okTitle: "ตกลง",
                    })
                    .then((value) => {
                      if (value) {
                        location.reload();
                      }
                    });
                } else {
                  this.$bvModal
                    .msgBoxOk(res.data.error, {
                      title: "ไม่สำเร็จ",
                      size: "sm",
                      buttonSize: "sm",
                      okVariant: "danger",
                      headerClass: "p-2 border-bottom-0",
                      footerClass: "p-2 border-top-0",
                      centered: true,
                      okTitle: "ตกลง",
                    })
                    .then((value) => {
                      if (value) {
                        location.reload();
                      }
                    });
                }
              });
          }
        });
    },
    unlock: function () {
      this.$bvModal
        .msgBoxConfirm("ยืนยันว่าปลดล็อคข้อมูลให้เเก้ไขใช่หรือไม่", {
          title: "ต้องการดำเนินการต่อไหม?",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          cancelVariant: "danger",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
          okTitle: "ตกลง",
          cancelTitle: "ยกเลิก",
        })
        .then((value) => {
          if (value) {
            axios
              .post(
                "https://www.kmppartners.info:1009/api/ebidding_customer/cancle_approved",
                {
                  customer_id: this.update_where,
                  username: this.$session.get("username"),
                  approved_by: this.approved_by,
                }
              )
              .then((res) => {
                if (res.data.status) {
                  this.$bvModal
                    .msgBoxOk("ดำเนินการเรียบร้อย", {
                      title: "สำเร็จ",
                      size: "sm",
                      buttonSize: "sm",
                      okVariant: "success",
                      headerClass: "p-2 border-bottom-0",
                      footerClass: "p-2 border-top-0",
                      centered: true,
                      okTitle: "ตกลง",
                    })
                    .then((value) => {
                      if (value) {
                        location.reload();
                      }
                    });
                } else {
                  this.$bvModal
                    .msgBoxOk(res.data.error, {
                      title: "ไม่สำเร็จ",
                      size: "sm",
                      buttonSize: "sm",
                      okVariant: "danger",
                      headerClass: "p-2 border-bottom-0",
                      footerClass: "p-2 border-top-0",
                      centered: true,
                      okTitle: "ตกลง",
                    })
                    .then((value) => {
                      if (value) {
                        location.reload();
                      }
                    });
                }
              });
          }
        });
    },
    selectCompany: function (params) {
      this.approved_by = params.row.approved_by;
      if (this.$session.get("role") === "Admin") {
        this.ctlLock = true;
        if (params.row.approved === "0") {
          this.approved = false;
        } else {
          this.approved = true;
        }
      } else {
        this.ctlLock = false;
      }
      this.update_where = params.row.ebidding_customer_id;
      axios
        .post("https://www.kmppartners.info:1009/api/ebidding/customer", {
          customer_id: params.row.ebidding_customer_id,
        })
        .then((res) => {
          console.log(res.data.response[0])
          if (res.data.statusCustomer) {
            this.form = res.data.response[0];
            if (this.$session.get("role") === "Customer") {
              axios.post(
                "https://www.kmppartners.info:1009/api/ebidding/access_log",
                {
                  access_username: this.$session.get("username"),
                  access_module:
                    "ดูข้อมูลผู้ชนะ E-Bidding(" +
                    this.form.ebidding_company_type +
                    " " +
                    this.form.ebidding_customer_name +
                    ")",
                  access_ipaddress: this.ipaddress,
                }
              );
            }
            if (res.data.response[0].ebidding_register_date === null) {
              this.form.ebidding_register_date = "00/00/0000";
            } else {
              this.form.ebidding_register_date =
                res.data.response[0].ebidding_register_date;
            }
            this.province = res.data.response[0].ebidding_changwat;
            if (res.data.response[0].ebidding_changwat !== null) {
              this.province = res.data.response[0].ebidding_changwat;
            } else {
              this.province = "";
            }
            if (res.data.response[0].ebidding_amphoe !== null) {
              this.amphoe = res.data.response[0].ebidding_amphoe;
            } else {
              this.amphoe = "";
            }
            if (res.data.response[0].ebidding_customer_zipcode !== null) {
              this.zipcode = res.data.response[0].ebidding_customer_zipcode;
            } else {
              this.zipcode = "";
            }
            if (res.data.response[0].ebidding_tel === null) {
              this.form.ebidding_tel = "";
            }
            if (res.data.response[0].ebidding_line === null) {
              this.form.ebidding_line = "";
            }
            if (res.data.response[0].ebidding_email === null) {
              this.form.ebidding_email = "";
            }
            if (res.data.response[0].latitude !== null) {
              this.form.latitude = res.data.response[0].latitude;
            } else {
              this.form.latitude = "";
            }
            axios
              .post(
                "https://www.kmppartners.info:1009/api/ebidding/committee",
                {
                  customer_id: params.row.ebidding_customer_id,
                }
              )
              .then((rest) => {
                if (rest.data.statusCommittee) {
                  if (rest.data.response.length === 0) {
                    this.haveCommittee = false;
                    this.position = null;
                  } else {
                    this.haveCommittee = true;
                    this.object_committee = rest.data.response;
                    this.position = rest.data.response[0].position;
                  }
                  this.$refs["modal-com"].show();
                } else {
                  this.$bvToast.toast(rest.data.error, {
                    title: "ผิดพลาด",
                    autoHideDelay: 5000,
                    appendToast: true,
                    variant: "danger",
                  });
                }
              });
          }
        });
    },
  },
};
</script>
<style scoped>
.box-list-company {
  min-height: 100%;
  width: 100%;
  position: absolute;
  background-color: rgb(231, 231, 231) !important;
}
.list-company {
  font-family: "K2D";
  margin: 3% !important;
  padding-bottom: 10%;
}
@media (max-width: 600px) {
  .list-company {
    padding-bottom: 80% !important;
  }
}
@media (max-width: 1024px) {
  .list-company {
    margin-bottom: 20% !important;
  }
}
</style>
